import { $http } from '../js/http.js'
export default {
  async reset(context) {
    context.commit('RESET')
  },

  async getProfile(context,payload) {
    if ((!context.state.profile.email && !context.state.profile.phone) || (payload && payload.action)) {
      let response = await $http.get('/api/accounts/profile/')
      context.commit('PROFILE', response)
    }
  },
  async getRealTimeInfo(context) {
    let response = await $http.get('/api/messages/real_time/')
    context.commit('SET_MESSAGE', response)
  },
  async getHoliday(context) {
    // let response = await $http.get('/api/holiday/')
    let data = {
      data:[
        // {
        //   banner_img: "",
        //   mobile_banner_img: "",
        //   create_time: "2024-09-01 00:00:00",
        //   title: "新年活动",
        //   banner_sub_heading: "Grab your limited-time 12% bonus now!",
        //   id: 1,
        //   banner_main_heading: "Unleash explosive app user growth this Black Friday!",
        //   popup_img: "",
        //   start: "2025.11.21 00:00:00",
        //   end: "2025.12.01 23:59:59",
        // }
      ]
    }
    let response = data.data
    context.commit('SET_HOLIDAY', response)
  },

}
